import React from "react";

function Performance() {
  return (
    <section className="about_section_three pt-0 ba">
      <div className="container">
        <div className="row">
          {/* Right Content */}
          <div className="col-xl-7 col-lg-7 col-md-12">
            <div
              className="about_right_content"
              data-aos="fade-left"
              data-aos-easing="linear"
              data-aos-duration="500"
            >
              <div className="section_title mb-4">
                <div className="tag_text">
                  <h6>Performance-Driven Excellence</h6>
                </div>
                <h2>Performance-Based Oppssortunities</h2>
                <p>
                  Eco Mantra Capital offers innovative partnership models
                  designed around performance metrics and targeted results.
                  Whether you're seeking franchise opportunities, strategic
                  partnerships, or employment, our approach focuses on
                  measurable outcomes.
                </p>
                <p>
                  We believe in rewarding excellence through our
                  performance-based compensation structure, ensuring all
                  stakeholders are aligned toward common goals and shared
                  success.
                </p>
                <h4>Available Opportunities:</h4>
              </div>

              <div className="row">
                {/* Left Column */}
                <div className="col-lg-6">
                  <div
                    className="feature_block_two"
                    data-aos="fade-up"
                    data-aos-easing="linear"
                    data-aos-duration="500"
                    data-aos-delay="100"
                  >
                    <div className="feature_content">
                      <ul className="feature-list">
                        <li>
                          <i class="fa-solid fa-circle-nodes"></i> Franchise
                          Opportunities
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div
                    className="feature_block_two"
                    data-aos="fade-up"
                    data-aos-easing="linear"
                    data-aos-duration="500"
                    data-aos-delay="200"
                  >
                    <div className="feature_content">
                      <ul className="feature-list">
                        <li>
                          <i class="fa-solid fa-circle-nodes"></i> Strategic
                          Partnerships
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Right Column */}
                <div className="col-lg-6">
                  <div
                    className="feature_block_two"
                    data-aos="fade-up"
                    data-aos-easing="linear"
                    data-aos-duration="500"
                    data-aos-delay="300"
                  >
                    <div className="feature_content">
                      <ul className="feature-list">
                        <li>
                          <i class="fa-solid fa-circle-nodes"></i>{" "}
                          Performance-Based Employment
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div
                    className="feature_block_two"
                    data-aos="fade-up"
                    data-aos-easing="linear"
                    data-aos-duration="500"
                    data-aos-delay="400"
                  >
                    <div className="feature_content">
                      <ul className="feature-list">
                        <li>
                          <i class="fa-solid fa-circle-nodes"></i>Investment
                          Partnerships
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Left Image */}
          <div className="col-xl-5 col-lg-5 col-md-12">
            <div
              className="about_left_image pe-0"
              data-aos="fade-right"
              data-aos-easing="linear"
              data-aos-duration="500"
            >
              <figure>
                <img
                  src="images/resource/performance-based.png"
                  alt="Performance Based"
                  style={{ borderRadius: "10px" }}
                />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Performance;
